export enum RefreshVoucherStatus {
  DEACTIVED = "DEACTIVED",
  ACTIVE = "ACTIVE",
  CALLED_OFF = "CALLED_OFF",
  UNSTRIPED = "UNSTRIPED",
  REACTIVE = "REACTIVE",
}
